import type { OnboardingStepId } from '../../models/organization';

export const GUIDE_STEP_ORDER: OnboardingStepId[] = [
  'intro',
  'product',
  'client',
  'order',
  'approve',
  'done',
];

export function nextGuideStep(
  id: OnboardingStepId | null | undefined
): OnboardingStepId {
  const idx = GUIDE_STEP_ORDER.indexOf(id ?? 'intro');
  if (idx < 0 || idx >= GUIDE_STEP_ORDER.length - 1) return 'done';
  return GUIDE_STEP_ORDER[idx + 1];
}

export function routeForStep(id: OnboardingStepId | null | undefined): string {
  switch (id) {
    case 'product':
      return '/inventory';
    case 'client':
      return '/clients';
    case 'order':
    case 'approve':
      return '/orders';
    default:
      return '/home';
  }
}

/** Whether live org data already satisfies this guide step. */
export function stepSatisfiedByCounts(
  id: OnboardingStepId | null | undefined,
  counts?: {
    products: number;
    clients: number;
    orders: number;
    approvedOrders: number;
  } | null
): boolean {
  if (!counts || !id) return false;
  switch (id) {
    case 'intro':
      return true;
    case 'product':
      return counts.products >= 1;
    case 'client':
      return counts.clients >= 1;
    case 'order':
      return counts.orders >= 1;
    case 'approve':
    case 'done':
      return counts.approvedOrders >= 1;
    default:
      return false;
  }
}
